const locale = {

    CANCEL: 'Cancel',
    SAVE: 'Save',
    REQUIRED: 'is required',

	PROFILE: 'Profile',
    PROFILE_INFO: 'Following information is visible to your team!',
    NAME: 'Name',
    USERNAME: 'Username',
    TITLE: 'Title',
    COMPANY: 'Company',
    NOTES: 'Notes',
    PERSONAL_INFO: 'Personal Information',
    CONTACT_DETAILS: 'Contact details in case we need to contact you.',
    EMAIL: 'Email',
    PHONE_NUMBER: 'Phone Number',
    COUNTRY: 'Country',
    LANGUAGE: 'Language',
	SELECT_LANGUAGE: 'Select language',
	BULGARIAN: 'Bulgarian',
    ENGLISH: 'English',
	DESCRIPTION: 'Description',

    ALERTS: 'Alerts',
	COMMUNICATION: 'Communication',
	GET_NEWS_ANNOUNCEMENTS_PRODUCT_UPDATES: 'Get news, announcements, and product updates.',
	SECURITY: 'Security',
	IMPORTANT_NOTIFICATIONS_ACCOUNT_SECURITY: 'Get important notifications about your account security.',
	MEETUPS: 'Meetups',
	EMAIL_WHEN_MEETUP_POSTED_NEAR: 'Get an email when a Meetup is posted close to my location.',
	ACCOUNT_ACTIVITY: 'Account Activity',
	EMAIL_ME_WHEN: 'Email me when:',
	SOMEONE_COMMENTS_ON_MY_ITEMS: 'Someone comments on one of my items',
	SOMEONE_MENTIONS_ME: 'Someone mentions me',
	SOMEONE_FOLLOWS_ME: 'Someone follows me',
	SOMEONE_REPLIES_TO_MY_JOB_POSTING: 'Someone replies to my job posting',


    CHANGE_YOUR_PLAN: 'Change your plan',
	UPGRADE_OR_DOWNGRADE_YOUR_CURRENT_PLAN: 'Upgrade or downgrade your current plan.',
	CHANGING_PLAN_TAKES_EFFECT_IMMEDIATELY: 'Changing the plan will take effect immediately. You will be charged for the rest of the current month.',
	PLAN_BASIC: 'Basic',
	PLAN_BASIC_DETAILS: 'Starter plan for individuals.',
	PLAN_TEAM: 'Team',
	PLAN_TEAM_DETAILS: 'Collaborate up to 10 people.',
	PLAN_ENTERPRISE: 'Enterprise',
	PLAN_ENTERPRISE_DETAILS: 'For bigger businesses.',
	PAYMENT_DETAILS: 'Payment Details',
	UPDATE_BILLING_INFORMATION: 'Update your billing information. Make sure to set your location correctly as it could affect your tax rates.',
	CARD_HOLDER: 'Card holder',
	CARD_NUMBER: 'Card number',
	EXPIRATION_DATE: 'Expiration date',
	CVC: 'CVC / CVC2',
	ZIP_CODE: 'ZIP / Postal code',

    CHANGE_PASSWORD: 'Change your password',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
	PASSWORD_CHANGE_LIMIT: 'You can only change your password twice within 24 hours!',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
	CURRENT_PASSWORD: 'Current password',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
	NEW_PASSWORD: 'New password',
	SECURITY_PREFERENCES: 'Security Preferences',
	SECURITY_PREFERENCES_DESC: 'Keep your account more secure with the following preferences.',
	ENABLE_2STEP_AUTH: 'Enable two-step authentication',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
	TWO_STEP_AUTH_DESC: 'Protects you from password theft by requiring an authentication code via SMS at each login.',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
	ASK_PASSWORD_CHANGE: 'Prompt for password change every 6 months',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
	PASSWORD_CHANGE_DESC: 'A simple but effective way to guard against data breaches and password theft.',

    ADD_TEAM_MEMBER: 'Add team member',
    ENTER_EMAIL: 'Enter email',

	SETTINGS: 'Settings',
    ACCOUNT: 'Account',
    ACCOUNT_SUBTITLE: 'Manage your public profile and personal information',
    SECURITY_SUBTITLE: 'Manage your password preferences and two-step authentication',
    PLAN_BILLING: 'Plan and Billing',
    PLAN_BILLING_SUBTITLE: 'Manage your subscription plan, payment method, and billing information',
    NOTIFICATIONS: 'Notifications',
    NOTIFICATIONS_SUBTITLE: 'Manage when and through which channels you receive notifications',
    TEAM: 'Team',
    TEAM_SUBTITLE: 'Manage your existing team and add new members',

	USERS: 'Users',
    HOTEL_TEXT: 'Use this page to manage users in DEMO HOTEL',
    INVITE_USER: '+ Invite user',
	INVITE: 'Invite',
    STATUS: 'Status',
    Search_by_email: 'Search by email',
    Enter_email: 'Enter email',
    ACTIONS: 'Actions',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
	ACTIVE_ITEM: 'Active Item',
	INACTIVE_ITEM: 'Inactive Item',
    
    // Roles
    ADMIN: 'Admin',
    RECEPTION: 'Reception',
    MAIN_CLEANER: 'Main Cleaner',
    CLEANER: 'Cleaner',
    TECH_SUPPORT: 'Tech Support',
    GODFATHER: 'Godfather',
    
    // Success Messages
    USER_INVITED_SUCCESS: 'User invited successfully',
    USER_DISABLED_SUCCESS: 'User successfully disabled',
    USER_ENABLED_SUCCESS: 'User successfully enabled',
    
    	// Error Messages
    FAILED_TO_FETCH_USERS: 'Failed to fetch users',
    FAILED_TO_INVITE_USER: 'Failed to invite user',
    FAILED_TO_CHANGE_USER_ROLE: 'Failed to change user role',
    FAILED_TO_DISABLE_USER: 'Failed to disable user. Please try again',
    FAILED_TO_ENABLE_USER: 'Failed to enable user. Please try again',
    
    // Pagination
    SHOWING: 'Showing',
    OF: 'of',
    PAGE: 'Page',

	EDIT_ROOM: 'Edit Room',
	CREATE_ROOM: 'Create Room',
	ROOM_MANAGEMENT: 'Room management',
	ROOM: 'Room',
	BEDS: 'Number of Beds',
	FLOOR: 'Floor',
	SELECT_FLOOR: 'Select Floor',
	CONFIRM_EDIT: 'Update Room',
	CONFIRM_CREATE: 'Create Room',
	
	// Floor management
	FLOOR_NAME: 'Floor Name',
	FLOOR_NUMBER: 'Floor Number',
	CREATE_FLOOR: 'Create Floor',
	EDIT_FLOOR: 'Edit Floor',
	CONFIRM_CREATE_FLOOR: 'Create Floor',
	CONFIRM_EDIT_FLOOR: 'Update Floor',
	FLOOR_MANAGEMENT: 'Floor Management',
	
	// Tabs
	FLOORS_TAB: 'Floors',
	ROOMS_TAB: 'Rooms',
	CHECKLISTS_TAB: 'Cleaning Checklists',

	// Room Types
	ROOM_TYPE: 'Room Type',
	SELECT_ROOM_TYPE: 'Select Room Type',
	SINGLE_ROOM: 'Single Room',
	DOUBLE_ROOM: 'Double Room',
	TWIN_ROOM: 'Twin Room',
	TRIPLE_ROOM: 'Triple Room',
	QUEEN_ROOM: 'Queen Room',
	KING_ROOM: 'King Room',
	STUDIO_ROOM: 'Studio Room',
	SUITE: 'Suite',
	JUNIOR_SUITE: 'Junior Suite',
	PRESIDENTIAL_SUITE: 'Presidential Suite',

	// Checklist management
	CHECKLIST_MANAGEMENT: 'Cleaning Checklist Management',
	CHECKLIST_MANAGEMENT_DESC: 'Create and manage cleaning checklists that will be used by cleaners during room cleaning sessions.',
	CHECKLIST_FEATURE_COMING_SOON: 'Cleaning checklist management feature will be available here soon.',
	
	// Checklist CRUD operations
	CREATE_CHECKLIST: 'Create Checklist',
	EDIT_CHECKLIST: 'Edit Checklist',
	UPDATE_CHECKLIST: 'Update Checklist',
	DELETE_CHECKLIST: 'Delete Checklist',
	
	// Checklist properties
	CHECKLIST_NAME: 'Checklist Name',
	DEFAULT: 'Default',
	SET_AS_DEFAULT_CHECKLIST: 'Set as default checklist',
	BASIC_INFORMATION: 'Basic Information',
	CHECKLIST_ASSIGN_TO_ROOM_TYPE: 'Assign to Room Type',
	CHECKLIST_ROOM_TYPE_DESC: 'Select a room type to assign this checklist only to that type of room. Leave empty to use as a general checklist.',
	
	// Maintenance Items
	MAINTENANCE_ITEMS_TAB: 'Maintenance Items',
	MAINTENANCE_ITEMS_MANAGEMENT: 'Maintenance Items Management',
	MAINTENANCE_ITEMS_MANAGEMENT_DESC: 'Manage maintenance items with multilingual support. These items are used when creating maintenance requests.',
	MAINTENANCE_ITEMS_ACCESS_DENIED: 'Access denied. Only Godfather and Admin users can manage maintenance items.',
	CREATE_MAINTENANCE_ITEM: 'Create Maintenance Item',
	EDIT_MAINTENANCE_ITEM: 'Edit Maintenance Item',
	DELETE_MAINTENANCE_ITEM: 'Delete Maintenance Item',
	DELETE_MAINTENANCE_ITEM_CONFIRM: 'Are you sure you want to delete the maintenance item "{{name}}"? This action cannot be undone.',
	SEARCH_MAINTENANCE_ITEMS: 'Search maintenance items...',
	ALL_CATEGORIES: 'All Categories',
	NO_MATCHING_ITEMS: 'No matching items found',
	NO_MAINTENANCE_ITEMS_FOUND: 'No maintenance items found',
	CREATE_FIRST_MAINTENANCE_ITEM: 'Create your first maintenance item to get started.',
	MAINTENANCE_ITEM_CREATED: 'Maintenance item created successfully',
	MAINTENANCE_ITEM_UPDATED: 'Maintenance item updated successfully',
	MAINTENANCE_ITEM_DELETED: 'Maintenance item deleted successfully',
	FAILED_TO_FETCH_MAINTENANCE_ITEMS: 'Failed to fetch maintenance items',
	FAILED_TO_SAVE_MAINTENANCE_ITEM: 'Failed to save maintenance item',
	FAILED_TO_DELETE_MAINTENANCE_ITEM: 'Failed to delete maintenance item',
	MAINTENANCE_ITEM_NAME_REQUIRED: 'At least one translation name is required',
	MAINTENANCE_ITEM_CATEGORY_REQUIRED: 'Category is required',
	MAINTENANCE_ITEM_TRANSLATIONS_DESC: 'Provide translations for each supported language. At least one translation is required.',
	ITEM_NAME: 'Item Name',
	REPLACEMENT_COST: 'Replacement Cost',
	SORT_ORDER: 'Sort Order',
	TRANSLATIONS: 'Translations',
	FURNITURE: 'Furniture',
	ELECTRONICS: 'Electronics',
	BATHROOM: 'Bathroom',
	LIGHTING: 'Lighting',
	OTHER: 'Other',
	
	// Checklist items
	CHECKLIST_ITEMS: 'Checklist Tasks',
	ADD_NEW_ITEM: 'Add New Task',
	EDIT_ITEM: 'Edit Task',
	ITEM_TITLE: 'Task Title',
	CATEGORY: 'Category',
	ESTIMATED_MINUTES: 'Estimated Minutes',
	REQUIRED_ITEM: 'Required Task',
	ADD_ITEM: 'Add Task',
	CURRENT_ITEMS: 'Current Tasks',
	
	// Checklist category options
	CHECKLIST_BEDROOM: 'Bedroom',
	CHECKLIST_BATHROOM: 'Bathroom',
	CHECKLIST_BOTH: 'Both',
	CHECKLIST_GENERAL: 'General',
	SELECT_CHECKLIST_CATEGORY: 'Select Category',
	
	// Checklist display
	ITEMS_COUNT: 'Number of tasks: {{count}}',
	PREVIEW_ITEMS: 'Preview Tasks',
	MORE_ITEMS: 'more tasks',
	NO_CHECKLISTS_FOUND: 'No checklists found',
	CREATE_FIRST_CHECKLIST: 'Create your first cleaning checklist to get started.',
	UPDATE_ITEM: 'Update Item',
	SAVING: 'Saving...',
	NO_FLOORS_FOUND: 'No floors found',
	NO_ROOMS_FOUND: 'No rooms found',
	
	// Checklist visibility settings
	SHOW_CHECKLIST_TO_CLEANERS: 'Show checklist to cleaners during cleaning',
	CHECKLIST_VISIBILITY_WARNING: 'If disabled, cleaners won\'t be able to check what items they have completed and the ability to check/uncheck items is now enabled only for the Main Cleaners.',
	CHECKLIST_VISIBILITY_SETTINGS: 'Checklist Visibility Settings',
	SETTINGS_UPDATED_SUCCESS: 'Settings updated successfully',
	SETTINGS_UPDATE_ERROR: 'Failed to update settings. Please try again.',

	// Room creation/update error messages
	ROOM_NUMBER_EXISTS_ERROR: 'A room with this number already exists',
	FLOOR_NOT_FOUND_ERROR: 'Selected floor not found',
	ROOM_CREATION_ERROR: 'Failed to create room. Please try again.',
	ROOM_NOT_FOUND_ERROR: 'Room not found',
	ROOM_UPDATE_ERROR: 'Failed to update room. Please try again.',
	ROOM_CREATION_SUCCESS: 'Room created successfully',
	ROOM_UPDATE_SUCCESS: 'Room updated successfully',
	ROOM_DELETION_SUCCESS: 'Room deleted successfully',
	ROOM_DELETION_ERROR: 'Failed to delete room. Please try again.',
	ROOM_DELETE_CONFIRM_TITLE: 'Confirm Room Deletion',
	ROOM_DELETE_CONFIRM_BODY: 'Are you sure you want to delete this room? This action cannot be undone.',
	CONFIRM: 'Confirm',
	PROCESSING: 'Removing...',
	
	INVALID_EMAIL: 'Invalid email',
	
	// RoomieAI
	CREATED_DATE: 'Created Date',

	// Main Cleaner Room Access Management
	MANAGE_ROOMS: 'Manage Rooms',
	MANAGE_ROOMS_DIALOG_TITLE: 'Manage Room Access for {{cleanerName}}',
	MANAGE_ROOMS_DIALOG_SUBTITLE: 'Select which rooms this Main Cleaner can see and access',
	MANAGE_ROOMS_SEARCH_PLACEHOLDER: 'Search rooms...',
	SELECT_ALL: 'Select All',
	DESELECT_ALL: 'Deselect All',
	SELECTED_ROOMS_COUNT_one: '{{count}} room selected',
	SELECTED_ROOMS_COUNT_other: '{{count}} rooms selected',
	FLOOR_ROOMS_COUNT_one: '{{count}} room',
	FLOOR_ROOMS_COUNT_other: '{{count}} rooms',
	NO_ROOMS_AVAILABLE: 'No rooms available',
	ROOMS_ASSIGNED_SUCCESS: 'Rooms assigned successfully',
	ROOMS_ASSIGNMENT_FAILED: 'Failed to assign rooms. Please try again.',
	LOADING_ROOMS: 'Loading rooms...',
	NO_USERS_FOUND: 'No users found',
	DISABLE_USER_TOOLTIP: 'Disable user access',
	ENABLE_USER_TOOLTIP: 'Enable user access',

};

export default locale;
